import { Router } from "../router";
import { router as browserRouter } from "./browser";
import { router as deployRouter } from "./deploy";
import { router as sessionRouter } from "./session";
import { router as terminalRouter } from "./terminal";
import { router as watchRouter } from "./watch";

export const router = new Router<any>();
router.include(browserRouter);
router.include(deployRouter);
router.include(sessionRouter);
router.include(terminalRouter);
router.include(watchRouter);
